import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const SECTIONS = [
  {
    title: '1. 収集する個人情報',
    content: '当サービスでは、転職サポートのために以下の情報を収集します：氏名、生年月日、メールアドレス、電話番号、郵便番号・住所、保有資格、ご希望の勤務条件、転職時期などの情報です。',
  },
  {
    title: '2. 個人情報の利用目的',
    content: '収集した個人情報は、以下の目的のみに使用します：(1) 求人情報のご提供・紹介、(2) 転職活動に関するアドバイスやサポート、(3) 採用企業への推薦・応募手続き、(4) サービス改善のための統計分析（個人を特定しない形式）。',
  },
  {
    title: '3. 個人情報の第三者提供',
    content: 'ご本人の同意なしに、個人情報を第三者に提供することはありません。ただし、ご本人が求人応募を希望した企業への情報提供は除きます。また、法令に基づく開示要請があった場合はこの限りではありません。',
  },
  {
    title: '4. 個人情報の管理・保護',
    content: '当サービスは、個人情報の漏洩・紛失・改ざんを防ぐため、適切な安全管理措置を講じます。個人情報へのアクセスは、業務上必要な担当者のみに制限されています。',
  },
  {
    title: '5. Cookieの使用',
    content: '本サービスでは、サービス改善のためにCookieを使用することがあります。Cookieは個人を特定する情報を含みません。ブラウザの設定によりCookieを無効にすることができますが、一部機能が制限される場合があります。',
  },
  {
    title: '6. 個人情報の開示・訂正・削除',
    content: 'ご自身の個人情報の開示、訂正、削除をご希望の場合は、お問い合わせフォームまたはLINEよりご連絡ください。ご本人確認の上、速やかに対応いたします。',
  },
  {
    title: '7. 未成年者の個人情報',
    content: '18歳未満の方から個人情報を収集することはありません。万が一、未成年者が個人情報を提供した場合は、速やかに削除いたします。',
  },
  {
    title: '8. プライバシーポリシーの変更',
    content: '本プライバシーポリシーは、法令の改正やサービス内容の変更に伴い改定される場合があります。重要な変更がある場合は、本サービス上でお知らせします。',
  },
  {
    title: '9. お問い合わせ',
    content: '個人情報の取り扱いに関するお問い合わせは、公式LINE（https://lin.ee/iLyZRQp）またはアドバイザーへ直接ご連絡ください。',
  },
];

export default function PrivacyPolicy() {
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom, #fff0f3, #fff)' }}>
      <Header />
      <main style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px 80px' }}>
        <div style={{ marginBottom: '32px' }}>
          <Link to="/" style={{ color: '#fa7c9e', fontSize: '13px', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
            <i className="ri-arrow-left-line" />
            トップへ戻る
          </Link>
        </div>

        <h1
          style={{
            fontFamily: "'Zen Maru Gothic', sans-serif",
            fontWeight: 900,
            fontSize: '28px',
            color: '#333',
            marginBottom: '8px',
          }}
        >
          プライバシーポリシー
        </h1>
        <p style={{ fontSize: '13px', color: '#999', marginBottom: '32px' }}>
          最終更新日: {new Date().getFullYear()}年{new Date().getMonth() + 1}月{new Date().getDate()}日
        </p>

        <p style={{ fontSize: '14px', color: '#555', lineHeight: 1.8, marginBottom: '32px', padding: '16px 20px', background: '#fff4f4', borderRadius: '8px', borderLeft: '4px solid #fa7c9e' }}>
          ニジ看護転職（厚生労働大臣許可証：13-ユ-317878）は、ご利用者様の個人情報の保護を最重要事項と位置づけ、以下のポリシーに基づいて適切に管理します。
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {SECTIONS.map((s, i) => (
            <section key={i}>
              <h2
                style={{
                  fontWeight: 700,
                  fontSize: '16px',
                  color: '#ff5c73',
                  marginBottom: '8px',
                }}
              >
                {s.title}
              </h2>
              <p style={{ fontSize: '14px', color: '#555', lineHeight: 1.8 }}>
                {s.content}
              </p>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
